import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { Grid, GridCell } from '../Grid';
import SearchField from '../SearchField';

const marketBrandsPagePropertyTypes = {
  keywords: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  children: PropTypes.node,
};

type MarketBrandsPageProperties = InferProps<
  typeof marketBrandsPagePropertyTypes
>;

const MarketBrandsPage = ({
  keywords,
  onChange,
  onClear,
  children,
}: MarketBrandsPageProperties) => (
  <Grid spacing={6}>
    <GridCell padding="0 20px 20px">
      <SearchField
        id="brands-search"
        label="Search for a Brand"
        value={keywords}
        onChange={onChange}
        onClear={onClear}
      />
    </GridCell>
    <GridCell padding="0 20px 20px">
      {children}
    </GridCell>
  </Grid>
);

MarketBrandsPage.propTypes = marketBrandsPagePropertyTypes;

MarketBrandsPage.defaultProps = {
  keywords: '',
  children: undefined,
};

export default MarketBrandsPage;
